"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ganttlab_use_cases_1 = require("ganttlab-use-cases");
var ganttStartString = process.env.VUE_APP_GANTT_START_STRING
    ? process.env.VUE_APP_GANTT_START_STRING
    : 'GanttStart:';
var ganttDueString = process.env.VUE_APP_GANTT_DUE_STRING
    ? process.env.VUE_APP_GANTT_DUE_STRING
    : 'GanttDue:';
function issueDescriptionToTaskDetails(description) {
    return ganttlab_use_cases_1.markdownToTaskDetails(description, {
        ganttStartString: ganttStartString,
        ganttDueString: ganttDueString,
    });
}
exports.issueDescriptionToTaskDetails = issueDescriptionToTaskDetails;
//# sourceMappingURL=helpers.js.map